module.exports = __webpack_public_path__ + "main/assets/public/flag-label/bars.e7576c77ec6bee5c.svg";